import React from "react";
import { UseCases } from "@planzone/core";
import { useModal } from "@root/client/modal";
import { ZoneAvatar } from "@common/zoneAvatar";
import { Controls } from "@common/treeToggle";
import { Safeguard } from "@scenes/safeguard";
import { Props } from "./types";
import styles from "./styles.scss";

function Zone({ zone }: Props) {
  const { pushView } = useModal();

  return (
    <div className={styles.project}>
      <div className={styles.main}>
        <div className={styles.wrapper}>
          <Safeguard useCases={[UseCases.editZone]}>
            {({ canEditZone }) => (
              <div
                className={styles.row}
                onClick={() =>
                  canEditZone &&
                  pushView({ data: zone, key: UseCases.editZone })
                }
              >
                <div className={styles.icon}>
                  <ZoneAvatar {...zone} />
                </div>
                <span className={styles.name}>{zone.name}</span>
              </div>
            )}
          </Safeguard>
          <div className={styles.buttons}>
            <Controls />
          </div>
        </div>
      </div>
    </div>
  );
}

export { Zone };
